// Дизайн-система проекта: база martyrs (слои) + JIT-утилиты + тема и шрифты
// OZ INTERACTIVE. Всё внутри @/design-system/index.js — единая точка подключения.
import '@/design-system/index.js';

import { createUniversalApp } from '@ozdao/martyrs/modules/core/client';

import { getConfig } from '@/configs/client.config.js';
import { getRouter } from '@/router/index.js';
import { getStore } from '@/store/index.js';
import { getLocales } from '@/localization/index.js';
import { textSplit } from '@/directives/textSplit.js';

// Создаем приложение используя фабрику
const appPromise = createUniversalApp({
  getConfig,
  getRouter,
  getLocales,
  getStore,
  getHooks: {
    beforeInitialize: async () => {
      performance.mark('init-start');

      // Блокируем скролл на клиенте
      if (typeof window !== 'undefined') {
        const screenElement = document.getElementById('screen');
        if (screenElement) {
          screenElement.style.overflow = 'hidden';
        }
      }
    },
    afterInitialize: ({ store, app }) => {
      performance.mark('init-end');

      // Регистрируем директиву v-text-split
      if (app) {
        app.directive('text-split', textSplit);
      }
    },
    beforeHydration: () => performance.mark('hydration-start'),
    afterHydration: ({ store }) => {
      performance.mark('hydration-end');

      // Custom initialization for events module
      if (store.events) {
        console.log('Events store initialized');
      }
    }
  }
});

export async function _renderApp({ url, cookies, languages, ssrContext }) {
  const { renderApp } = await appPromise;
  
  return renderApp({ url, cookies, languages, ssrContext });
}